import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { useMemo } from "react";
import type { ColumnDef } from "../../components/base-table-layout";
import { createEhrWriteBackColumn } from "../../ehr/create-ehr-column";
import { useEhrContext } from "../../../shared-logic/ehr-context/ehr-context";
import { BaseTableLayout } from "../../components/base-table-layout";
import { TableRow } from "../../utils/tables-metadata";
import { AllergyRowData } from "./allergy-rows";

export type AllergyTableProps = {
  rows: TableRow[];
  onRowClick: (row: TableRow) => void;
  fhirSdk: FhirBundleSdk;
  filterQuery: string;
  onPdfView?: (docId: string) => void;
  displayName?: string;
};

export function AllergyTable({
  rows,
  onRowClick,
  filterQuery,
  displayName = "Allergies",
}: AllergyTableProps) {
  const ehrContext = useEhrContext();

  const columns = useMemo<ColumnDef<AllergyRowData>[]>(() => {
    const cols: ColumnDef<AllergyRowData>[] = [
      { key: "allergy", header: "Allergy" },
      { key: "manifestation", header: "Manifestation" },
      { key: "firstSeen", header: "First Seen", maxWidth: "150px" },
    ];

    const ehrColumn = createEhrWriteBackColumn<AllergyRowData>(ehrContext, "allergy");
    if (ehrColumn) cols.push(ehrColumn);

    return cols;
  }, [ehrContext]);

  function handleRowClick(row: TableRow) {
    onRowClick(row);
  }

  return (
    <BaseTableLayout
      title={displayName}
      rows={rows as unknown as AllergyRowData[]}
      columns={columns}
      filterQuery={filterQuery}
      onRowClick={handleRowClick}
    />
  );
}
